import { API_BASE } from "./server";
const API = API_BASE;


export async function login(username, password) {
  const res = await fetch(`${API}/users/auth/login/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Inloggning misslyckades");
  }
  return res.json();
}

export async function fetchMe() {
  const res = await fetch(`${API}/users/auth/me/`, {
    credentials: "include",
  });
  if (res.status === 401 || res.status === 403) return null;
  if (!res.ok) throw new Error(`fetchMe failed: ${res.status}`);
  return res.json();
}

export async function logout() {
  await fetch(`${API}/users/auth/logout/`, {
    method: "POST",
    credentials: "include",
  });
}
export async function forgotPassword(email) {
  const res = await fetch(`${API}/users/auth/forgot-password/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.detail || "Misslyckades");
  }
}

export async function resetPassword(token, password) {
  const res = await fetch(`${API}/users/auth/reset-password/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.detail || "Misslyckades");
  }
}
